import { SearchProps } from "../../interfaces";

const Search = ({ value, handleSearch, placeholder = "" }: SearchProps) => {
  return (
    <div className="w-72 bg-white rounded-full px-3 py-2 cursor-pointer">
      <label htmlFor="search " className="">
        <div className="flex items-center ">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6  text-gray-400 hover:text-gray-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
          <input
            placeholder={placeholder}
            type="text"
            id="search"
            className="border-none outline-none placeholder:text-md placeholder:text-secondaryText"
            value={value}
            onChange={(e) => handleSearch(e)}
          />
        </div>
      </label>
    </div>
  );
};

export default Search;
